<template>
  <div>
    <Modal v-model="visible" title="服务费" :closable="true" :mask-closable="false" width="1100" :footer-hide="true" class="my-modal p-b">
      <div class="serve-info">
        <loading :isShow="pageLoading" />
        <!-- <div class="tools-box">
          <Button type="primary" :loading="btnLoading" @click="generateCommission">重新生成费用</Button>
        </div> -->
        <template v-if="!pageLoading && list.length == 0">
          <span v-if="noCommissionReason" class="error-box">{{ noCommissionReason }}</span>
          <noData v-else class="null-box"></noData>
        </template>
        <!-- 费率表 -->
        <commissionInfoTable v-else class="modal-use" :list="list"></commissionInfoTable>
      </div>
    </Modal>
  </div>
</template>

<script>
import commissionInfoTable from '@/pages/orderManage/group/policy/components/commissionInfoTable';
export default {
  components: { commissionInfoTable },
  data() {
    return {
      visible: false,
      pageLoading: false,
      btnLoading: false,
      list: [],
      noCommissionReason: '', // 无费用原因
    };
  },
  methods: {
    open(policyNo, billNo) {
      this.getDetail(policyNo, billNo);
      this.visible = true;
    },

    getDetail(policyNo, billNo) {
      this.pageLoading = true;
      this.$http({
        url: '/buz/endorsement/commission',
        type: 'GET',
        data: {
          policyNo,
          billNo
        }
      })
        .then(res => {
          this.list = res.data.commissionInfoVoList;
          this.noCommissionReason = res.data.noCommissionReason;
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
  }
};
</script>

<style lang="scss" scoped>
.serve-info  {
  padding-top: 20px;
  min-height: 200px;
  /deep/ .fee-table {
    max-height: calc(100vh - 200px);
    overflow-y: auto;
  }
}
.error-box {
  color: red;
  text-align: center;
  padding-top: 30px;
  width: 100%;
  display: block;
}
</style>
